import React, { useState, useRef, useEffect } from "react";
import styles from "../decimal.module.css";
import { TextField } from "@mui/material";

export default function DecimalUI(props) {
  const {
    key_id,
    field,
    title,
    onUpdate,
    enableQuery,
    length,
    value_position = "value",
    value_name_position = "value_name",
    units = "",
    item_specific_error_validator,
    setParentFieldError,
    value,
    onChange,
    whole_length = 2,
    decimal_length = 1,
    error,
    disabled = false,
  } = props;

  const ref = useRef(null);

  // const local_validation = (value => /^[0-9]{1,12}$/.test(value);

  const onKeyDown = (key) => {
    if (key.keyCode === 13) {
      ref.current.blur();
    }
  };

  const onBlur = () => {
    onUpdate();
  };

  const is_error = () => {
    if (value?.length === 0) {
      //this is used for randomization checking and flogic at the form level
      setParentFieldError && setParentFieldError(key_id, true);
      return false;
    } else {
      let error = !local_validation(value);
      if (item_specific_error_validator && item_specific_error_validator.constructor === Function) {
        error = local_validation() || item_specific_error_validator(value);
      }

      //this is used for randomization checking and flogic at the form level
      setParentFieldError && setParentFieldError(key_id, error);
      return error;
    }
  };

  const local_validation = (value) => {
    if (
      RegExp(/^[0-9]{1,5}[.]{1}[0-9]{1,3}$/).test(value) ||
      RegExp(/^[0-9]{1,5}[.]$/).test(value) ||
      RegExp(/^([0-9.]+){0,4}$/).test(value)
    ) {
      // let split = value.split(".");
      return true;
      // if (
      //   split[0].length === whole_length &&
      //   split[1].length === decimal_length
      // ) {
      //   return true;
      // } else {
      //   return false;
      // }
    } else {
      return false;
    }
  };

  let placeHolder = () => {
    if (whole_length && decimal_length) {
      return Array(whole_length).fill("0").join("") + "." + Array(decimal_length).fill("0").join("");
    } else {
      return "0.0";
    }
  };
  return (
    <React.Fragment>
      <div className={styles.decimal_wrapper}>
        <TextField
          type="text"
          inputRef={ref}
          placeholder={placeHolder() || ""}
          value={value}
          onChange={(e) => {
            let value = e.target.value;

            onChange(value);

            if (is_error(value)) {
              setParentFieldError && setParentFieldError(key_id, true);
            } else {
              setParentFieldError && setParentFieldError(key_id, false);
            }
          }}
          inputProps={{ maxLength: length }}
          autoComplete="off"
          onKeyDown={onKeyDown}
          onBlur={onBlur}
          sx={{
            "& .MuiInputBase-input": {
              padding: "5px",
              textAlign: "center",
              width: `${(whole_length + decimal_length) * 10 + 30}px`,
              fontSize: 14,
            },
          }}
          error={error || is_error()}
          disabled={disabled}
        />
        {units ? <div className={styles.input_description}>{units}</div> : null}
      </div>
    </React.Fragment>
  );
}
